import { useState } from 'react';
import { Copy } from '../../copy/Copy';
import {
  padding0Sx,
  tabPanelContainerSx,
  tableTabPanelContainerSx,
} from '../../styles/Global.style';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { NavTabBar } from '../../components/NavTabBar/NavTabBar';
import TabContext from '@mui/lab/TabContext/TabContext';
import TabPanel from '@mui/lab/TabPanel/TabPanel';
import { PROFILE_NAV_TABS } from '../../constants/profile';
import { Activities } from '../../components/Activities/Activities';
import { Summary } from '../../components/Summary/Summary';
import { Achievements } from '../../components/Achievements/Achievements';
import { ModalContainer } from '../../containers/ModalContainer/ModalContainer';
import { Welcome } from '../../components/Welcome/Welcome';
import { useWelcomeModal } from '../../hooks/useWelcomeModal/useWelcomeModal';

export const Profile = () => {
  const [tabValue, setTabValue] = useState('1');
  const { toggleWelcomeModal, isWelcomeModalOpen } = useWelcomeModal();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer title={Copy.generate('Global.profile')}>
      <TabContext value={tabValue}>
        <NavTabBar
          handleChange={handleTabChange}
          ariaLabel="Profile tab bar"
          tabs={PROFILE_NAV_TABS}
        />

        <TabPanel id="section" value="1" sx={tabPanelContainerSx}>
          <Summary />
        </TabPanel>

        <TabPanel id="section" value="2" sx={tableTabPanelContainerSx}>
          <Activities />
        </TabPanel>

        <TabPanel id="section" value="3" sx={tabPanelContainerSx}>
          <Achievements />
        </TabPanel>
      </TabContext>

      <ModalContainer
        isOpen={isWelcomeModalOpen}
        onClose={toggleWelcomeModal}
        dialogContentOverrideSx={padding0Sx}
      >
        <Welcome />
      </ModalContainer>
    </PageContainer>
  );
};
